import React, { useState } from "react";
import { Box, Collapse, Stack, Typography, Popover, IconButton } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import Circle from "@mui/icons-material/Circle";
import { ExpandMore } from "@mui/icons-material";
import { styled } from "@mui/material/styles";

export const LegendIconButton = styled(IconButton)(({ top }) => ({
  position: "absolute",
  width: "29px",
  height: "29px",
  top: top || "40px",
  right: "10px",
  zIndex: 500,
  border: "1px solid rgba(0, 0, 0, 0.3)",
  borderRadius: "5px",
  backgroundColor: "white",
  "&:hover": {
    backgroundColor: "rgb(243, 243, 243)"
  }
}));

// 開閉用の共通部品
const ExpandableHeader = ({ label, expanded, toggle, sx = {} }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
      userSelect: "none",
      mb: 0.5,
      ...sx,
    }}
    onClick={toggle}
  >
    <ExpandMore
      sx={{
        transform: expanded ? "rotate(0deg)" : "rotate(-90deg)",
        transition: "transform 0.2s",
        fontSize: 16,
        mr: 0.5,
      }}
    />
    <Typography sx={{ fontSize: "0.75rem" }}>{label}</Typography>
  </Box>
);


// 複数の凡例をループ表示する部品
const SectionItem = ({ label, colorMap }) => {
  const [open, setOpen] = useState(false);
  const toggleSection = () => setOpen((prev) => !prev);

  return (
    <Box sx={{ pt: 1, pl: 2 }}>
      <ExpandableHeader
        label={label}
        expanded={open}
        toggle={toggleSection}
        sx={{ mb: 0.25 }}
      />
      <Collapse in={open}>
        <Stack direction="column" spacing={0.5} pl={1}>
          {Object.entries(colorMap)
            .filter(([level]) => level !== "OTHER")
            .map(([level, item], index) => (
              <Box key={index} sx={{ display: "flex", alignItems: "center" }}>
                <Circle sx={{ color: item.color, fontSize: "10px" }} />
                <Typography sx={{ fontSize: "10px", pl: 1, minWidth: 60 }}>
                  {item.label}
                </Typography>
              </Box>
            ))}
        </Stack>
      </Collapse>
    </Box>
  );
};

// メインコンポーネント
const MapLegendIcon = ({ top, sections }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [legendOpen, setLegendOpen] = useState(false);
  const open = Boolean(anchorEl);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <LegendIconButton top={top} onClick={handleClick}>
        <InfoIcon sx={{ width: "21px", height: "21px" }} />
      </LegendIconButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Box sx={{ p: 1, maxHeight: 300, overflowY: "auto" }}>
          <ExpandableHeader
            label="凡例"
            expanded={legendOpen}
            toggle={() => setLegendOpen(!legendOpen)}
          />
          <Collapse in={legendOpen}>
            {sections.map((sec) => (
              <SectionItem
                key={sec.key}
                label={sec.label}
                colorMap={sec.colorMap}
              />
            ))}
          </Collapse>
        </Box>
      </Popover>
    </>
  );
};

export default MapLegendIcon;
